import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import EventBus from '~/nasa_ui/modules/EventBus';
/**
 * Mixin to automatically stop listening to EventBus events when a component is destroyed.
 * This mixin shadows the prototype $listen and $stopListening methods to track listeners
 * per component instance.
 */
let AutoStopListeningMixin = class AutoStopListeningMixin extends Vue {
    _autoListeners = [];
    /**
     * Listens to an event and tracks it for automatic cleanup.
     * @param name - The name of the event to listen for.
     * @param callback - The callback function to be called when the event is heard.
     * @returns The event handler function.
     */
    $listen = (name, callback) => {
        const handler = EventBus.listen(name, callback);
        this._autoListeners.push({
            name,
            handler
        });
        return handler;
    };
    /**
     * Stops listening to an event and removes it from tracked listeners.
     * @param name - The name of the event to stop listening for.
     * @param handler - The event handler function.
     */
    $stopListening = (name, handler) => {
        EventBus.stopListening(name, handler);
        this._autoListeners = this._autoListeners.filter((l) => l.handler !== handler);
    };
    /**
     * Automatically stops listening to all tracked events before the component is destroyed.
     */
    beforeDestroy() {
        if (this._autoListeners && this._autoListeners.length > 0) {
            this._autoListeners.forEach(({ name, handler }) => {
                EventBus.stopListening(name, handler);
            });
            this._autoListeners = [];
        }
    }
};
AutoStopListeningMixin = __decorate([
    Component
], AutoStopListeningMixin);
export default AutoStopListeningMixin;
